import { Injectable, inject } from '@angular/core';

import { HeaderHttpInterceptor } from '@ng-gems/api';

import { AuthService } from '@app/core/services/auth.service';
import { OktaService } from '@app/core/services/okta.service';

@Injectable()
export class HeaderInjectorService extends HeaderHttpInterceptor {
  protected authService = inject(AuthService);
  protected oktaService = inject(OktaService);

  getLanguage() {
    return this.authService.user?.lang;
  }

  getApiKey() {
    return this.authService.user?.apiKey;
  }

  getAuthorizationHeader() {
    return this.oktaService.authorizationHeader();
  }
}
